import React, { useState } from 'react';
import { Card, Form, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { PHAMVIHANHNGHE_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { Button } from '@components';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    tenPhamViHanhNghe: yup
        .string()
        .required('Tên phạm vi hành nghề không được để trống')
        .max(255, 'Tên phạm vi hành nghề không được vượt quá 255 ký tự')
});

const PhamViHanhNgheAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) => Post(PHAMVIHANHNGHE_API.ADD_ITEM, null, value, false));

    const handleCreate = async (values) => {
        const model = values;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới phạm vi hành nghề</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        tenPhamViHanhNghe: ''
                    }}>
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Tên phạm vi hành nghề',
                                        name: 'tenPhamViHanhNghe',
                                        value: values.tenPhamViHanhNghe,
                                        onChange: handleChange,
                                        isInvalid: errors.tenPhamViHanhNghe,
                                        error: errors.tenPhamViHanhNghe
                                    }
                                ]}
                            />

                            <Form.Group className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={isLoading}>
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.PHAMVIHANHNGHE_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                {isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default PhamViHanhNgheAdd;